<template>
  <div class="fs-breadcumb">
    <span v-if="!subItem.descricao">
      <span class="page">{{ item.descricao }}</span>
      <span class="modulo">{{ item.descricao }}</span>
    </span>
    <span v-else>
      <span class="page">{{ subItem.descricao }}</span>
      <span class="modulo">{{ item.descricao }}
      <span v-if="!this.$vuetify.breakpoint.mdAndDown">/ {{ subItem.descricao }}</span></span>
    </span>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      path: this.$router.currentRoute.path,
      item: {},
      subItem: {}
    }
  },
  computed: {
    ...mapState({
      itemMenu: state => state.menu.itemMenu,
      subItemMenu: state => state.menu.subItemMenu
    })
  },
  watch: {
    '$route' (to, from) { this.atualizarBreadcumb() }
  },
  async mounted () {
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.items = userInfo.acesso.modulos
    this.items.find(item => {
      item.telas.find(item2 => {
        if (item2.web_url === this.path) {
          this.setItemMenu(item)
          this.setSubItemMenu(item2)
          this.item = this.itemMenu
          this.subItem = this.subItemMenu
        }
      })
    })
  },
  methods: {
    ...mapMutations({
      setItemMenu: 'menu/setItemMenu',
      setSubItemMenu: 'menu/setSubItemMenu'
    }),
    atualizarBreadcumb () {
      if (this.path !== this.$router.currentRoute.path) {
        this.item = this.itemMenu
        this.subItem = this.subItemMenu
        this.path = this.$router.currentRoute.path
      }
    }
  }
}
</script>

<style scoped>
.fs-breadcumb {
  border-bottom: 1px solid rgb(231, 231, 231);
  background-color: white;
  padding: 10px 0px 0px 13px;
  letter-spacing: .3px;
  height: 47px;
}
.page {
  font-size: 19px;
  font-weight: 500;
}
.modulo {
  font-size: 12px;
  margin-left: 10px;
  letter-spacing: .3px;
}
</style>
